<template>
  <div class="right-chart-1" id="right-chart-1"></div>
</template>

<script>
import { querymrlsbjcbwcstop } from '@/api/modules/dataView.js'
export default {
  name: 'RightChart1',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      config: null,
      chart: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      const container = document.getElementById('right-chart-1')
      this.chart = this.$echarts.init(container)
      this.getData()
    })
  },
  methods: {
    async getData() {
      const apiData = await querymrlsbjcbwcstop(this.date)
      let chartsDatas = []
      apiData.forEach(item => {
        chartsDatas.push({
          value: item.yxsysc_bwjccs,
          name: item.hxcs_position,
        })
      })
      const options = {
        title: {
          text: 'MR类设备检查部位次数列表',
          left: 'center',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {},
        legend: {
          type: 'scroll',
          pageIconColor: '#70f3ff',
          pageIconInactiveColor: '#065279',
          bottom: 10,
          formatter: function(text) {
            const tLength = text.length
            let result = ''
            if (tLength > 5) {
              result = text.substring(0, 5) + '...'
            } else {
              result = text
            }
            return result
          },
          tooltip: {
            show: true,
          },
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          bottom: 10,
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            label: {
              formatter: function(data) {
                return data.percent.toFixed(0) + '%'
              },
              show: true,
              textStyle: {
                color: '#fff',
              },
              position: 'inner',
            },
            insideLabel: {
              show: true,
            },
            labelLine: {
              show: false,
            },
            data: chartsDatas,
          },
        ],
      }
      this.chart.setOption(options)
    },
  },
}
</script>

<style lang="scss" scoped>
.right-chart-1 {
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: column;
}
</style>
